import * as glb from '../globals.js';

/** Admin veya genel yetkili */
export function isReportFullAccessUser(user = glb.default?.KULLANICI) {
  if (!user) return false;
  return !!(
    user.KUL_ISADMIN
    || Number(user.KUL_YETKI) === 0
    || Number(user.KUL_YS) === 0
  );
}

/** Rapor API gövdesi: sınırlı kullanıcıda xkul_yetki=3 ve kendi KUL_REF */
export function buildReportScopeFields(user = glb.default?.KULLANICI) {
  const kulRef = Number(user?.kulid ?? user?.KUL_REF ?? 0);
  if (isReportFullAccessUser(user)) {
    return {
      xkul_kul_ref: kulRef,
      xkul_yetki: user?.KUL_REF != null ? Number(user.KUL_YETKI) : -1,
    };
  }
  return {
    xkul_kul_ref: kulRef,
    xkul_yetki: 3,
  };
}

export function sanitizeReportFilterPayload(payload, user = glb.default?.KULLANICI) {
  const scope = buildReportScopeFields(user);
  const next = { ...payload, ...scope };
  if (!isReportFullAccessUser(user)) {
    next.CD_SAT_REF = -1;
    next.CAR_EKIM_YAPAN_REF = -1;
    next.CD_YETK_REF = -1;
  }
  return next;
}
